import React, {useState,Fragment} from "react";
import  "./ContactUs.css";
import Form from "./Form";
import Accordion from "../../containers/Accordion/Accordion"
import Attach from "../../../dist/assets/Attach.png";


const ContactUs = React.memo(props => {
    return (
    <Fragment>
        { props.layout == "first" ?
        <Form siteUrl={props.siteUrl} mailTo={props.mailTo} />
        :
        <Fragment>
        {/* {props.items && props.items.length >0 && */}
        {/* <h2 className="modArticaleTitle">{props.title}</h2> */}
        <Accordion items={props.items} 
        WpId={props.WpId}
        layout={props.layout}
        type={props.type}
        handleUserKeypress = {props.handleUserKeypress}
        // limit={props.limit}
        // moreTitle={props.moreTitle} 
        openItem={props.openItem}/>
        {/* } */}
    </Fragment>
    }

    </Fragment>
    );
});
export default ContactUs;